<template>
  <section class="oa-process-download">
    <el-card class="search-card">
      <el-alert
        title="使用说明"
        type="info"
        description="请先选择时间类型（创建时间或接收时间），然后选择对应的日期区间，系统将导出该时间范围内的OA流程数据为Excel文件。创建时间和接收时间只能二选一。"
        show-icon
        style="margin-bottom: 20px;">
      </el-alert>
      <el-form :model="searchForm" :rules="rules" ref="searchForm" label-width="120px" class="search-form">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="请选择时间类型：" :label-width="'180px'" required class="time-type-item">
              <el-radio-group v-model="timeType" @change="onTimeTypeChange" class="time-type-radio-group">
                <el-radio :label="1">创建时间区间</el-radio>
                <el-radio :label="2">接收时间区间</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" v-if="timeType === 1" class="date-range-col">
            <el-form-item label="创建时间区间：" :label-width="'180px'" prop="createTimeRange" :rules="timeType === 1 ? rules.createTimeRange : []" class="date-range-item">
              <el-date-picker
                v-model="searchForm.createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="timeType === 2" class="date-range-col">
            <el-form-item label="接收时间区间：" :label-width="'180px'" prop="receiveTimeRange" :rules="timeType === 2 ? rules.receiveTimeRange : []" class="date-range-item">
              <el-date-picker
                v-model="searchForm.receiveTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" class="button-group">
            <el-button type="primary" @click="handleDownload" :loading="downloading">
              <i class="el-icon-download"></i>
              下载Excel
            </el-button>
            <el-button @click="handleReset">
              <i class="el-icon-refresh"></i>
              重置
            </el-button>
            <el-button @click="handleExportTemplate">
              <i class="el-icon-document"></i>
              导出模板
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </section>
</template>

<script>
import { GetOAData, GetDownloadStatus, DownFile1 } from '../../api/api';
import { Notification } from 'element-ui';

export default {
  name: 'OaProcessDownload',
  data() {
    return {
      timeType: 1, // 1: 创建时间, 2: 接收时间
      searchForm: {
        createTimeRange: [],
        receiveTimeRange: []
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      rules: {
        createTimeRange: [
          { required: true, message: '请选择创建时间区间', trigger: 'change' },
          { validator: this.validateDateRange, trigger: 'change' }
        ],
        receiveTimeRange: [
          { required: true, message: '请选择接收时间区间', trigger: 'change' },
          { validator: this.validateDateRange, trigger: 'change' }
        ]
      },
      downloading: false
    }
  },
  methods: {
    async handleDownload() {
      try {
        // 表单验证
        const valid = await this.$refs.searchForm.validate();
        if (!valid) {
          this.$message({ message: '请检查输入的筛选条件', type: 'warning' });
          return;
        }

        // 构造请求参数
        const params = {};
        if (this.timeType === 1 && this.searchForm.createTimeRange && this.searchForm.createTimeRange.length === 2) {
          params.createStartTime = this.searchForm.createTimeRange[0];
          params.createEndTime = this.searchForm.createTimeRange[1];
        } else if (this.timeType === 2 && this.searchForm.receiveTimeRange && this.searchForm.receiveTimeRange.length === 2) {
          params.receiveStartTime = this.searchForm.receiveTimeRange[0];
          params.receiveEndTime = this.searchForm.receiveTimeRange[1];
        } else {
          this.$message({ message: '请选择时间区间', type: 'warning' });
          return;
        }

        this.downloading = true;
        
        // 构造搜索条件字符串，确保日期格式正确
        let searchCondition = '';
        const formatDate = (date) => {
          if (date instanceof Date) {
            return date.toISOString().split('T')[0];
          } else if (typeof date === 'string') {
            if (date.includes('GMT')) {
              // 如果是完整的日期字符串，转换为 yyyy-MM-dd
              return new Date(date).toISOString().split('T')[0];
            } else {
              // 已经是 yyyy-MM-dd 格式
              return date;
            }
          }
          return date;
        };
        
        if (this.timeType === 1 && params.createStartTime && params.createEndTime) {
          const startDate = formatDate(params.createStartTime);
          const endDate = formatDate(params.createEndTime);
          searchCondition = this.timeType + ';' + startDate + ';' + endDate;
        } else if (this.timeType === 2 && params.receiveStartTime && params.receiveEndTime) {
          const startDate = formatDate(params.receiveStartTime);
          const endDate = formatDate(params.receiveEndTime);
          searchCondition = this.timeType + ';' + startDate + ';' + endDate;
        }
        
        // 1. 提交任务
        const submitResponse = await GetOAData(searchCondition);
        if(submitResponse.data.response === 0) {
          this.$message({ message: submitResponse.data.msg, type: 'warning' });
          return;
        }
        // 根据你的响应结构，taskId 应该直接在 response 字段中
        const taskId = submitResponse.data.response;
        // 2. 轮询状态
        await this.pollDownloadStatus(taskId);

        console.log('OA流程下载成功');
      } catch (error) {
        console.error('导出OA流程失败:', error);
        this.$message.error(error.message || '导出失败');
      } finally {
        this.downloading = false;
      }
    },

    // 轮询下载状态
    async pollDownloadStatus(taskId) {
      // 创建一个可复用的通知实例
      let progressNotification = null;
      
      while (true) {
        // 根据你的API修改，参数名已改为 taskid
        const statusResponse = await GetDownloadStatus(taskId);
        
        // 打印完整的响应数据以便调试
        console.log('完整的状态响应数据:', statusResponse.data);
        
        // 根据你的响应结构，status信息在response字段中
        const Status = statusResponse.data.response.Status;
        const Filename = statusResponse.data.response.Filename;
        
        // 检查状态值是否存在
        if (!Status) {
          Notification.warning({
            title: '警告',
            message: '无法获取任务状态',
            duration: 4500
          });
        }
        
        if (Status === '下载完成') {
          // 关闭进度通知
          if (progressNotification) {
            progressNotification.close();
          }
          
          try {
            // 调用下载方法
            const response = await DownFile1(Filename);
            // 使用通用下载方法处理文件
            this.downloadFileFromResponse(response, Filename);
            Notification.success({
              title: '下载完成',
              message: '后台处理下载文件',
              duration: 4500
            });
          } catch (error) {
            // 在.catch中处理下载失败的情况，如显示错误提示等
            Notification.error({
              title: '下载完成',
              message: "下载报销报告失败: " + (error.message || "未知错误"),
              duration: 4500
            });
          }
          
          break;
        } else if (Status === 'failed' || Status === '失败') {
          // 关闭进度通知
          if (progressNotification) {
            progressNotification.close();
          }
          
          Notification.error({
            title: '错误',
            message: '后台任务执行失败',
            duration: 4500
          });
        } else {
          // 更新或创建进度通知
          const messageText = "后台数据处理中：" + Status;
          if (progressNotification) {
            // 更新现有通知的内容
            progressNotification.message = messageText;
          } else {
            // 创建新的通知并保存引用
            progressNotification = Notification.info({
              title: '正在处理',
              message: messageText,
              duration: 0 // 设置为0表示不会自动关闭
            });
          }
          
          // 等待2秒后继续轮询
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
      }
    },

    handleReset() {
      this.timeType = 1;
      this.$refs.searchForm.resetFields();
      // 清除验证状态
      this.$refs.searchForm.clearValidate();
      // 重置时间范围
      this.searchForm.createTimeRange = [];
      this.searchForm.receiveTimeRange = [];
    },
    
    handleExportTemplate() {
      // 创建一个简单的Excel模板
      const templateData = [
        ['OA流程数据模板'],
        ['创建时间', '接收时间', '流程名称', '申请人', '状态'],
        ['', '', '', '', ''],
        ['', '', '', '', '']
      ];
      
      // 创建Excel文件
      let csvContent = "data:text/csv;charset=utf-8,";
      templateData.forEach(row => {
        csvContent += row.join(",") + "\n";
      });
      
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "OA流程模板.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.$message({
        message: '模板导出成功',
        type: 'success'
      });
    },
    
    onTimeTypeChange() {
      // 清除另一个时间范围
      if (this.timeType === 1) {
        this.searchForm.receiveTimeRange = [];
      } else {
        this.searchForm.createTimeRange = [];
      }
      // 清除验证状态
      this.$refs.searchForm.clearValidate();
    },
    
    validateDateRange(rule, value, callback) {
      if (value && value.length === 2) {
        const [start, end] = value;
        if (start && end) {
          // 检查结束时间不能早于开始时间
          if (new Date(start) > new Date(end)) {
            callback(new Error('结束日期不能早于开始日期'));
          } else {
            // 检查时间范围不能超过一年
            const timeDiff = new Date(end).getTime() - new Date(start).getTime();
            const daysDiff = timeDiff / (1000 * 3600 * 24);
            if (daysDiff > 365) {
              callback(new Error('时间范围不能超过一年'));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      } else {
        callback();
      }
    },

    /**
     * 通用文件下载方法
     * @param {*} response axios返回的响应
     * @param {String} defaultFileName 默认文件名
     */
    downloadFileFromResponse(response, defaultFileName = 'download.xlsx') {
      try {
        // 获取文件名
        let fileName = defaultFileName;
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }

        // 创建并下载文件
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('文件下载失败:', error);
        this.$message({ message: "文件下载失败: " + (error.message || "未知错误"), type: "error" });
      }
    }
  },
  mounted() {
    // 初始化时间类型为创建时间
    this.timeType = 1;
    // 初始化时设置默认时间范围为最近一个月
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    this.searchForm.createTimeRange = [start, end];
  }
}
</script>

<style scoped>
.oa-process-download {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.search-form {
  padding: 20px 0;
}

.time-type-item .el-form-item__label {
  white-space: nowrap;
}

.time-type-item .el-radio {
  margin-right: 20px;
}

.time-type-radio-group {
  display: flex;
  flex-wrap: wrap;
}

.date-range-item .el-form-item__label {
  white-space: nowrap;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .date-range-col {
    width: 100%;
    margin-bottom: 15px;
  }
  
  .date-range-item .el-form-item__label {
    white-space: normal;
  }
  
  .time-type-item .el-radio {
    display: block;
    margin-bottom: 10px;
    margin-right: 0;
  }
  
  .time-type-radio-group {
    display: block;
  }
}

.button-group {
  text-align: center;
  margin-top: 20px;
}

.button-group .el-button {
  margin: 0 10px;
}

@media screen and (max-width: 768px) {
  .button-group .el-button {
    margin: 5px;
  }
}
</style>